import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import { InformationService } from 'services';
import { LightImage } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Message extends React.Component<Props> {

	state = {
		form: {
			agent_id: '',
			message_length: '',
		},
		agents: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await InformationService.getData({
			user_id: this.props.user?.id
		});
		this.setState({
			agents: res.agents || [],
			form: {
				...this.state.form,
				agent_id: res.person?.agent_id || '',
				message_length: res.person?.message_length || ''
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		await InformationService.updateAgentData({
			...this.state.form
		});
		Globals.showSuccess("Se ha modificado correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setMessageLength = (message_length: number) => {
		this.setState({
			form: {
				...this.state.form,
				message_length
			}
		});
	}

	render() {
		const { 
			SHORT,
			MEDIUM,
			LARGE
		} = Constants.MESSAGE_LENGTH;

		return (
			<div id="client-agent-message">
				<form onSubmit={ this.submit } className="form-black">
					<Select
						color="white"
						placeholder="Seleccionar"
						name="agent_id"
						label="Tipo de agente"
						onChange={ this.change }
						value={ this.state.form.agent_id }
						options={ this.state.agents.map((i: any) => {
							return {
								label: i.name,
								value: i.id
							}
						}) } />
					{
						this.state.form.agent_id == Constants.AGENTS.APPOINTMENTS.toString() && (
							<div className="container-light">
								<img src={ LightImage } />
								<div style={{ flex: 1 }}>
									<p>Para el correcto funcionamiento del agente de reserva de citas, debe configurar su cuenta de Google Calendar en el módulo <Link to="/client/api">conexión de canales.</Link></p>
									<p>Puede cambiar la configuración de las citas en el módulo <Link to="/client/information">conocimiento</Link>.</p>
								</div>
							</div>
						)
 					}
					<h6>Tamaño de la respuesta</h6>
					<p className="subtitle">Indica la longitud de las interaciones o respuestas que el agente realizará con tus usuarios</p>
					<div className="container-message-buttons">
						<div className="row">
							<div className="col-md-4">
								<button type="button" className={ `btn btn-message-length ${ this.state.form.message_length == SHORT.toString() ? 'active' : '' }` } onClick={ () => this.setMessageLength(SHORT) }>
									Corta
								</button>
							</div>
							<div className="col-md-4">
								<button type="button" className={ `btn btn-message-length ${ this.state.form.message_length == MEDIUM.toString() ? 'active' : '' }` } onClick={ () => this.setMessageLength(MEDIUM) }>
									Media
								</button>
							</div>
							<div className="col-md-4">
								<button type="button" className={ `btn btn-message-length ${ this.state.form.message_length == LARGE.toString() ? 'active' : '' }` } onClick={ () => this.setMessageLength(LARGE) }>
									Larga
								</button>
							</div>
						</div>
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Message);